import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ref, onBeforeMount, watch, toRefs } from 'vue'
import { IonContent, IonPage } from "@ionic/vue";
import router from '@/router';
import { getComputedPageLayout, getIcon, IPageLayout } from '@/helpers/api';
import ModalMessage from '@/globals/components/ModalMessage.vue';
import { useModalManager } from '@/modules/a.worksheets/services/modalManager';
import { useDeviceStatus } from '@/stores/deviceStatus';

interface _062X extends IPageLayout {
    labels: {
        title: string,
        lines: Array<string>
        button: string
    }
    icons: {icon: string}
    commands: {
        router: string
    }
}


export default /*@__PURE__*/_defineComponent({
  __name: 'CompletedModal',
  props: {
    screenId: { type: String, required: true }
},
  setup(__props) {

const props = __props

const { isWeb } = toRefs(useDeviceStatus());


const title = ref('')
const button = ref('')
const icon = ref<string>()
const description = ref< Array<string> >([])
const router_path = ref('')

const layout = getComputedPageLayout<_062X>(props.screenId)
onBeforeMount(async () => {
    icon.value = await getIcon(props.screenId, 'icon')
})

watch(layout, l => {
    if(l){
        title.value = l.labels.title
        description.value = l.labels.lines
        button.value = l.labels.button
        router_path.value = l.commands.router
    }
}, {immediate: true})


const modalManager = useModalManager()
function routeAway(){
    modalManager.close()
    if(router_path.value) router.push(router_path.value)
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonPage), null, {
    default: _withCtx(() => [
      _createVNode(_unref(IonContent), {
        "force-overscroll": !_unref(isWeb)
      }, {
        default: _withCtx(() => [
          _createVNode(ModalMessage, {
            icon: icon.value,
            title: title.value,
            button: {textContent: button.value, danger: false},
            description: description.value,
            onButtonClick: _cache[0] || (_cache[0] = ($event: any) => (routeAway()))
          }, null, 8, ["icon", "title", "button", "description"])
        ]),
        _: 1
      }, 8, ["force-overscroll"])
    ]),
    _: 1
  }))
}
}

})